import { Form, Input } from 'antd';
import { FC, useEffect } from 'react';
import { IProductDetailId } from '../../../../../types/products';

interface IFurniture {
  productDataDetail?: IProductDetailId;
  setVerifySpecs: (isVerify: boolean) => void;
}

const Furniture: FC<IFurniture> = ({ productDataDetail, setVerifySpecs }: IFurniture) => {
  const weight = Form.useWatch('weight');
  const width = Form.useWatch('width');
  const length = Form.useWatch('length');
  const height = Form.useWatch('height');
  const material = Form.useWatch('material');

  const verifyGroup = () => {
    if (material) {
      setVerifySpecs(true);
    } else {
      setVerifySpecs(false);
    }
  };
  useEffect(() => {
    verifyGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weight, width, length, height, material]);
  return (
    <>
      <div className="firstSection">
        <div className="mediumItem">
          <div className="titleForm">{'Peso neto (Opcional)'}</div>
          <Form.Item initialValue={productDataDetail?.weight} name="weight">
            <Input className="inputTabs" placeholder="Ej. 10 Kg" />
          </Form.Item>
        </div>
        <div className="smallItem">
          <div className="titleForm">{'Ancho (Opcional)'}</div>
          <Form.Item initialValue={productDataDetail?.width} name="width">
            <Input className="inputTabs" placeholder="Ej. 100 cm" />
          </Form.Item>
        </div>
        <div className="smallItem">
          <div className="titleForm">{'Alto (Opcional)'}</div>
          <Form.Item initialValue={productDataDetail?.height} name="height">
            <Input className="inputTabs" placeholder="Ej. 100 cm" />
          </Form.Item>
        </div>
        <div className="smallItem noMargin">
          <div className="titleForm">{'Largo (Opcional)'}</div>
          <Form.Item initialValue={productDataDetail?.length} name="length">
            <Input className="inputTabs" placeholder="Ej. 100 cm" />
          </Form.Item>
        </div>
      </div>
      <div className="secondSection">
        <div className="mediumItem">
          <div className="titleForm">Material</div>
          <Form.Item
            initialValue={productDataDetail?.material}
            name="material"
            rules={[{ required: true, message: 'campo requerido' }]}
          >
            <Input className="inputTabs" placeholder="Ej. Madera" />
          </Form.Item>
        </div>
        <div className="mediumItem">
          <div className="titleForm">Color (opcional)</div>
          <Form.Item name="color" initialValue={productDataDetail?.color}>
            <Input className="inputTabs" placeholder="Ej. Negro" />
          </Form.Item>
        </div>
      </div>
    </>
  );
};
export default Furniture;
